import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import Footer from "../Footer";
import Navbar from "../Navbar";
import API_ROUTES from "../../constants/apis";

const VerifyOtp = () => {
  const [formData, setFormData] = useState({
    email: "",
    otp: "",
  });

  const [responseMessage, setResponseMessage] = useState("");
  const [emailMessage, setEmailMessage] = useState("");
  const [otpMessage, setOtpMessage] = useState("");

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(API_ROUTES.VERIFY_OTP, formData);

      if (response.data.status === 200) {
        navigate("/login");
      } else if (response.data.status === 400) {
        setResponseMessage(response.data.data);
      } else if (response.data.status === 450) {
        if (response.data.data.email && response.data.data.otp) {
          setEmailMessage("Email Required");
          setOtpMessage("OTP Required");
        } else if (response.data.data.email) {
          setEmailMessage("Email Required");
        } else if (response.data.data.otp) {
          setOtpMessage("OTP Required");
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (responseMessage || emailMessage || otpMessage) {
      const timer = setTimeout(() => {
        setResponseMessage("");
        setOtpMessage("");
        setEmailMessage("");
      }, 3000); // Hide message after 3 seconds

      return () => {
        clearTimeout(timer);
      };
    }
  }, [responseMessage, emailMessage, otpMessage]);

  return (
    <div className="bg-slate-300 flex flex-col justify-between h-screen">
      <Navbar />
      <div className="bg-slate-300 flex flex-col items-center justify-center px-5 pt-30 mt-40 mb-10">
        <p className="mb-10 text-center text-green-700">
          Thank you for registering an account with our platform! <br /> To activate
          your account and gain access to our services,<br />Enter the <span className="font-bold">One-Time Password (OTP)</span>  sent to your <span className="font-bold">Registered Email</span> below.
        </p>
        <form
          onSubmit={handleSubmit}
          className="max-w-sm mx-auto rounded-md text-blue-950 bg-white/5 p-15"
        >
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            className="w-full border-b border-blue-950 rounded-md py-2 px-4 focus:outline-none"
          />
          {emailMessage && (
            <p className="text-center text-red-600 mt-2">{emailMessage}</p>
          )}
          <input
            type="text"
            name="otp"
            placeholder="OTP"
            value={formData.otp}
            onChange={handleChange}
            className="w-full border-b border-blue-950 rounded-md py-2 px-4 focus:outline-none mt-2"
          />
          {otpMessage && (
            <p className="text-center text-red-600 mt-2">{otpMessage}</p>
          )}
          <button
            type="submit"
            className="w-full bg-red-600 hover:bg-red-700 text-white p-2 rounded-md mt-2"
          >
            Verify OTP
          </button>
          <div>
            {responseMessage && (
              <p className="text-center text-red-600 mt-2">{responseMessage}</p>
            )}
          </div>
          <p className="text-center text-sky-500 mt-2">Resend Otp?</p>
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default VerifyOtp;
